// src/components/PresentationModal/PresentationModal.jsx
import { toSafeSimpleHtml } from "../../utils/safeHtml.js";
import "./PresentationModal.css";
import LazyVideo from "./LazyVideo";
import { useState,useRef ,useEffect} from "react";
import { X } from "lucide-react";
//import { useModalBehavior } from "../../hooks/useModalBehavior";
import { useEscapeKey } from "../../hooks/useEscapeKey";
// Dans le composant
//import { parseContentWithComponents } from "../../utils/parseContentMailto.js";
import PresentationModalPresentation from "./PresentationModalPresentation.jsx";

const PresentationModal = ({ visible, onClose, content, cible = "presentation" }) => {
  const [tab, setTab] = useState(cible);//useState("presentation");
  const divRef = useRef(null);
  //useModalBehavior(visible, onClose);
  useEscapeKey(onClose, visible);


  // Remet le scroll à zéro quand les données changent
  useEffect(() => {
    if (divRef.current) {
      divRef.current.scrollTop = 0;
    }
  }, [tab]); // Dépendance sur ce qui doit déclencher le reset
  
  if (!visible) return null;

  const textMentions = content?.mentions || "Aucun texte";
  const strMentions = toSafeSimpleHtml(textMentions);

  const textMentionsTitre = content?.mentionsTitre || "Aucun texte";
  const strMentionsTitre = toSafeSimpleHtml(textMentionsTitre);



  return (
    /* <div className="presentation-modal"></div>*/

    <div className="presentation-overlay" onClick={onClose}>
      <div
        className="presentation-box"
        onClick={(e) => e.stopPropagation()} // évite la fermeture si on clique dans la boîte
      >
        {/* Barre du haut */}
        <div className="presentation-modal-header">
          <div className="header-content">
            {/* Onglets */}
            <div className="modal-tabs">
              <button
                className={tab === "presentation" ? "active" : ""}
                onClick={() => setTab("presentation")}
              >
                présentation
              </button>
              <button
                className={tab === "demo" ? "active" : ""}
                onClick={() => setTab("demo")}
              >
                tuto
              </button>
              <button
                className={tab === "mentions" ? "active" : ""}
                onClick={() => setTab("mentions")}
              >
                mentions légales
              </button>
            </div>

            {/* Bouton fermer */}
            <button className="modal-presentation-close" onClick={onClose} aria-label="Fermer">
              <X size={20} strokeWidth={2}/>
            </button>
          </div>
        </div>

        {/* Contenu */}
        <div className="presentation-modal-content"
        ref={divRef} 
        >
          {tab === "presentation" && (
            <PresentationModalPresentation content={content} />
          )}

          {tab === "demo" && (
            <div className="presentation-video">
              {/* vidéo existante */}
              <LazyVideo src="/videos/demo.mp4" poster="/videos/demo.jpg" />
            </div>
          )}

          {tab === "mentions" && (
            <div className="presentation-content-wrapper">
              {/* Mentions légales */}
              <div
                className="presentation-mentions-title"
                dangerouslySetInnerHTML={{ __html: strMentionsTitre }}
              />
              <div
                className="presentation-mentions"
                dangerouslySetInnerHTML={{ __html: strMentions }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PresentationModal;
